<template>
  <div class="content-article">
    <div class="content-title">{{ articleDetail.title }}</div>
    <div class="content-info">
      <span class="content-info-date">
        日期 ：{{ articleDetail.publishedAt }}
      </span>
      <span>作者：{{ articleDetail.author }}</span>
    </div>
    <div class="ql-container ql-snow">
      <div class="ql-editor content-chunk" v-html="articleDetail.content"></div>
      <div class="file-chunk" v-show="articleDetail.files.length > 0">
        <span>文章附件：</span>
        <div class="footer-file">
          <div
            v-for="(item, index) in articleDetail.files"
            :key="index"
            class="footer-file-children"
            @click="downloadFile(item.url)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div
        class="footer-children"
        v-if="articleDetail.previousPage"
        @click="changPage(articleDetail.previousPage)"
      >
        上一篇：{{
          articleDetail.previousPage
            ? articleDetail.previousPage.title
            : '没有了哦！'
        }}
      </div>
      <div
        class="footer-children"
        v-if="articleDetail.nextPage"
        @click="changPage(articleDetail.nextPage)"
      >
        下一篇：{{
          articleDetail.nextPage ? articleDetail.nextPage.title : '没有了哦！'
        }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    articleDetail: Object,
  },
  // created() {
  //   this.articleDetail.files = JSON.parse(this.articleDetail.files);
  // },
  methods: {
    changPage(item) {
      this.$http
        .get(`/open/cms/category?filter=id||eq||${item.categoryId}`)
        .then((res) => {
          if (res.data.data[0].parentId) {
            this.$http
              .get(
                `/open/cms/category?filter=id||eq||${res.data.data[0].parentId}`
              )
              .then((data) => {
                this.$store.commit('eidtBreadcrumb', data.data.data[0].id);
                this.$router.push({
                  name: 'articleList',
                  query: {
                    selectMenuId: data.data.data[0].id,
                    type: 'article',
                    selectMoreId: res.data.data[0].id,
                    articleId: item.id,
                  },
                });
              });
          } else {
            this.$store.commit('eidtBreadcrumb', res.data.data[0].id);
            this.$router.push({
              name: 'articleList',
              query: {
                selectMenuId: res.data.data[0].id,
                type: 'article',
                articleId: item.id,
              },
            });
          }
        });
    },
    downloadFile(url) {
      window.location.href = url;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  &-title {
    text-align: center;
    color: #ff7f00;
    font-weight: bold;
    font-size: 25px;
  }
  &-info {
    text-align: center;
    margin: 15px;
    font-size: 12px;
    &-date {
      margin-right: 30px;
    }
  }
  &-chunk {
    width: 100%;
  }
}
.footer {
  margin-top: 30px;
  &-children {
    padding: 5px 0;
    cursor: pointer;
    &:hover {
      color: #2d8cf0;
    }
  }
  &-file {
    display: inline-block;
    vertical-align: top;
    &-children {
      display: block;
      cursor: pointer;
      &:hover {
        color: #2d8cf0;
      }
    }
  }
}
.file-chunk {
  padding: 15px;
}
</style>
